_ = require 'underscore'
ApiError = require 'network/api-error'
Auth = require 'db/auth'
ModelCache = require 'db/model-cache'
ModelLoader = require 'db/model-loader'
Payloads = require 'network/payloads'
Promise = require 'bluebird'
SidebarState = require 'view-models/sidebar-state'

module.exports = class RecentBoards
  _idBoardsFetching: []

  _fetchUnknownBoards: (idBoards, fetchUnknownBoardsCallback) ->
    idBoardsMissing = _.chain idBoards
    .difference @_idBoardsFetching
    .reject (idBoard) => ModelCache.get('Board', idBoard)?
    .value()

    return if idBoardsMissing.length == 0

    @_idBoardsFetching = @_idBoardsFetching.concat(idBoardsMissing)

    boards = idBoardsMissing.map (idBoard) =>
      ModelLoader.loadBoardData idBoard, Payloads.boardMinimal
      .catch ApiError.NotFound, ApiError.Unauthorized, ->
        SidebarState.pullBoard(idBoard)

    Promise.all boards
    .then =>
      @_idBoardsFetching = _.difference @_idBoardsFetching, idBoardsMissing
      if fetchUnknownBoardsCallback
        fetchUnknownBoardsCallback(idBoardsMissing)
      return
    .done()

  getBoards: (model, fetchUnknownBoardsCallback) ->
    me = Auth.me()
    _.chain SidebarState.getRecentBoards()
    .difference model.boardStarList.getBoardIds()
    .tap (idBoards) => @_fetchUnknownBoards(idBoards, fetchUnknownBoardsCallback)
    .map (idBoard) => ModelCache.get('Board', idBoard)
    .compact()
    .filter (board) => board.isViewableBy(me) && board.isOpen()
    .value()



// WEBPACK FOOTER //
// ./app/scripts/lib/recent-boards.coffee